<div [class.collapsed]="isCollapsed$ | async"
     [class.dropdown-open]="dropdownOpen$ | async"
     [ngClass]="levelClass"
     class="sidenav-item">
     <ng-container *ngIf="isCategory()">
        <div *ngIf="returnValue('type') === 'subheading'" [ngClass]="returnValue('customClass') ?? ''"
          class="subheading">{{ item?.name }}
        </div>
     </ng-container>
     <ng-container *ngIf="isItem()">
        <div *ngIf="returnValue('type') === 'subheading'" [ngClass]="returnValue('customClass') ?? ''"
          class="subheading">{{ item?.name }}
        </div>
      </ng-container>

  <ng-container *ngIf="isCategory()">
    <ng-container *ngIf="returnValue('type') !== 'subheading'">
      <ng-container *ngIf="hasSubItems(item) || isFunction(returnValueCategory('categoryRouteOrFunction')); then functionOrSubItems; else link"></ng-container>
    </ng-container>


    <ng-template #functionOrSubItems>
      <a (click)="handleClick()"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple>
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #link>
      <a [routerLinkActiveOptions]="{ exact: returnValueActive('route') || false }"
        [routerLink]="returnValue('route')"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple
        routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #linkContent>
      <mat-icon *ngIf="level === 0" class="icon">{{ returnValue('icon') }}</mat-icon>
      <div *ngIf="level > 0" class="text-icon" fxFlex="none">{{ getTextIcon(item) }}</div>
      <span class="name">{{ item?.name }}</span>
      <span fxFlex><!-- fill space --></span>
      <span *ngIf="returnValue('badge')" [style.background-color]="returnValue('badgeColor')" class="badge">{{ returnValue('badge') }}</span>
      
      <mat-icon *ngIf="hasSubItems(item)" [class.rotate]="dropdownOpen$ | async"
                class="expand-indicator">
        expand_more
      </mat-icon>
    </ng-template>

    <div [@dropdownOpen]="dropdownOpen$ | async" class="dropdown" fxLayout="column">
      <ng-container *ngIf="hasSubItems(item)">
        <app-sidenav-item-revolution *ngFor="let subItem of returnValue('items')" [item]="subItem" [level]="level+1"></app-sidenav-item-revolution>
      </ng-container>
    </div>

  </ng-container>

  <ng-container *ngIf="isItem()">
    <ng-container *ngIf="returnValue('type') !== 'subheading'">
      <ng-container *ngIf="hasSubItems(item) || isFunction(returnValueItem('itemRouteOrFunction')); then functionOrSubItems; else link"></ng-container>
    </ng-container>


    <ng-template #functionOrSubItems>
      <a (click)="handleClick()"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple>
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #link>
      <a [routerLinkActiveOptions]="{ exact: returnValueActive('route') || false }"
        [routerLink]="returnValue('route')"
        class="sidenav-item-link"
        fxLayout="row"
        fxLayoutAlign="start center"
        matRipple
        routerLinkActive="active">
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #linkContent>
      <mat-icon *ngIf="level === 0" class="icon">{{ returnValue('icon') }}</mat-icon>
      <div *ngIf="level > 0" class="text-icon" fxFlex="none"> - </div>
      <span class="name">{{ item?.name }}</span>
      <span fxFlex><!-- fill space --></span>
      <span *ngIf="returnValue('badge')" [style.background-color]="returnValue('badgeColor')" class="badge">{{ returnValue('badge') }}</span>
      
      <mat-icon *ngIf="hasSubItems(item)" [class.rotate]="dropdownOpen$ | async"
                class="expand-indicator">
        expand_more
      </mat-icon>
    </ng-template>

  </ng-container>

</div>
